<div class="wrapper-lineup {{typeTeam}}">
  <div
    (click)="changeNavPage(-1)"
    class="nav-left"
    [class.disabled]="currentPageLineUp === 0"
    *ngIf="this.team.players.length > maxVisiblePlayer">
    <img src="/assets/img/icons/positive-dark/arrow_pag.svg">
  </div>
  <ul
    [class.fade]="fadeClass"
    [class.disabled]="disabled"
    [class.with-nav]="team.players.length > maxVisiblePlayer"
    >
    <li *ngFor="let player of currentVisibleTeam"
        (click)="selectPlayer(player, $event)"
        [class.selected]="player?.id === _selected?.id">
      <span
        class="player"
        [class.frontline]="!live && player.frontline"
        [class.playing]="live && stats[player.id] && stats[player.id].playing">
        <span *ngIf="!live" class="player-tooltip">
          {{ player.number }}.
          {{ player.name }}
          <span *ngIf="player.frontline">({{ 'First team' | translate }})</span>
        </span>
        <span *ngIf="live" class="player-tooltip white">
          {{ player.name }}
          <ng-container *ngIf="stats[player.id] && stats[player.id].playing">{{ 'is playing' | translate }}</ng-container>
          (<ng-container *ngIf="stats[player.id] && stats[player.id].fouls; else noFouls">{{stats[player.id].fouls }} {{ 'fouls' | translate }}</ng-container><ng-template #noFouls>{{ 'No fouls' | translate }}</ng-template>)
        </span>
        <img
          src="{{ player.img }}"
          (error)="onImageError($event)">
      </span>
      <div *ngIf="live && stats[player.id] && stats[player.id].fouls > 0" class="fouls">
        {{ stats[player.id].fouls }}
      </div>
    </li>
  </ul>
  <div
    (click)="changeNavPage(1)"
    class="nav-right"
    [class.disabled]="(currentPageLineUp + 1) > totalPageLineUp"
    *ngIf="this.team.players.length > maxVisiblePlayer">
    <img src="/assets/img/icons/positive-dark/arrow_pag.svg">
  </div>
</div>
